
const ListTable = require('app/ui/list/Table');
const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');
const IframeModal = require('app/ui/modal/IFrame');

class UpdateView {
    defaultOptions() {
        return {
            'selector': '.view-product-price-update',
            'tableContainerSelector': '.product-price-update-container',
            'filterFormSelector': '.product-price-update-search-form',

            'productShowBaseUrl': window.App.get('productShowBaseUrl'),
            'maxLength': 1000,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$tableContainer = $(this.settings.tableContainerSelector,this.$container);
        this.$filterForm =  $(this.settings.filterFormSelector,this.$container);
        this.$selectTarget = $('select[name="target"]',this.$container);

        this.$allActionsContainer = $('.all-actions',this.$container);
        this.$btnExportPdf = $('.btn-export-pdf',this.$allActionsContainer);
        this.$btnExportExcel = $('.btn-export-excel',this.$allActionsContainer);

        this.$allActionsContainer.hide();

        this.initialize();
    }

    initialize() {
        var self = this;

        this.initializeFilterForm();
        this.bindEvents();

        this.$filterForm.trigger('submit');
    }

    initializeFilterForm(){
        var self = this;

        window.select2(this.$selectTarget);

        this.$filterByNumber = $('input[name="number"]',this.$filterForm);
        this.$filterByNumber.on('change',this.onSubmitFilterForm);

        this.$filterByReference = $('input[name="reference"]',this.$filterForm);
        this.$filterByReference.on('change',this.onSubmitFilterForm);

        this.$filterByRange = $('select[name="range"]',this.$filterForm);
        this.$filterByRange.on('change',this.onSubmitFilterForm);

        this.$filterBySupplier = $('select[name="supplier"]',this.$filterForm);
        this.$filterBySupplier.on('change',this.onSubmitFilterForm);

        this.$selectTarget.on('change',this.onSubmitFilterForm);

        this.$filterForm.on('submit',this.onSubmitFilterForm);

    }

    onSubmitFilterForm(event){
        event.preventDefault()
        event.stopPropagation();

        this.loadData();
    }

    refresh(callback){
        this.loadData(callback);
    }

    loadData(callback){
        if(!callback){
            callback = function(){};
        }
        if(this.$selectTarget.val() == 'all'){
            this.loadForAll(callback);
        }else{
            this.loadForRestaurant(callback);
        }
    }


    loadForAll(callback){
        var self = this;
        this.target = null;
        this.$allActionsContainer.show();

        this.$tableContainer
        .html('')
        .append(window.App.generateLoader());

        let queries = [
            this.buildProductQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildListTable(data);
                callback();
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){

            }
        });

        query.execute();

    }

    loadForRestaurant(callback){
        var self = this;
        this.target = parseInt(this.$selectTarget.val());
        this.$allActionsContainer.hide();

        this.$tableContainer
        .html('')
        .append(window.App.generateLoader());

        let queries = [
            this.buildProductQuery(),
            this.buildRestaurantProductQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildListTable(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
                callback();
            }
        });

        query.execute();
    }


    buildProductQuery(){
        var self = this;

        let filters = {
            'notStatus': 3,
        };

        if(this.$filterByNumber && this.$filterByNumber.val()){
            filters.number = this.$filterByNumber.val();
        }

        if(this.$filterByReference && this.$filterByReference.val()){
            filters.reference = '%'+this.$filterByReference.val()+'%';
        }

        if(this.$filterByRange && this.$filterByRange.val()){
            filters.rootRange = parseInt(this.$filterByRange.val());
        }

        if(this.$filterBySupplier && this.$filterBySupplier.val()){
            filters.supplier = parseInt(this.$filterBySupplier.val());
        }

        let orderBy = 'reference';
        let dir = "ASC";
        let parameters = {
            'first': this.settings.maxLength,
            'filter' : filters,
            'orderBy': orderBy,
            'dir': dir,
        };

        let fields = [
            'id',
            'number',
            'reference',
            'price',
            'supplierPrice',
            'supplierPriceViewable',
            'status',
            'supplier { id name rfa }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProducts',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }


    buildRestaurantProductQuery(){
        var self = this;

        let filters = {
        };

        if(this.$filterByNumber && this.$filterByNumber.val()){
            filters.number = this.$filterByNumber.val();
        }

        if(this.$filterByReference && this.$filterByReference.val()){
            filters.reference = '%'+this.$filterByReference.val()+'%';
        }

        if(this.$filterByRange && this.$filterByRange.val()){
            filters.rootRange = parseInt(this.$filterByRange.val());
        }

        if(this.$filterBySupplier && this.$filterBySupplier.val()){
            filters.supplier = parseInt(this.$filterBySupplier.val());
        }

        let parameters = {
            'first': 1000,
            'restaurant': this.target,
            'filter': filters,
        };

        let fields = [
            'product { id }',
            'realPrice',
            'realStatus'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantProducts',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    buildRowId(id){
        return 'productPrice'+id;
    }

    buildListTable(data){
        var self = this;
        let listData = this.compileListData(data);


        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped product-price-update',
            'id': 'list-productPriceUpdates',
            'length': 0,
            'rowIdCallback': function(item){
                return self.buildRowId(item.id);
            },
            'data': listData,
            'columns': [
                {
                    'name': 'product',
                    'label': window.translate('app.product.price.update.list.product.label'),
                    'class': 'product',
                    'render': function(item,index){
                        let url = self.settings.productShowBaseUrl.replace('__ID__',item.id);
                        let $content = $('<div/>')
                        .append(
                            $('<div/>')
                            .append(item.reference)
                        )
                        .append(
                            $('<div/>')
                            .append(
                                $('<small/>')
                                .append(window.translate('app.product.price.update.list.product.number'))
                                .append(' : ')
                                .append(
                                    $('<a/>')
                                    .attr('target','_blank')
                                    .attr('href',url)
                                    .append(item.number)
                                )
                            )
                        )
                        .append(
                            $('<div/>')
                            .append(
                                $('<small/>')
                                .append(window.translate('app.product.price.update.list.product.supplier'))
                                .append(' : ')
                                .append(item.supplier.name)
                            )
                        )
                        return $content;
                    },
                },
                {
                    'name': 'status',
                    'label': window.translate('app.product.price.update.list.status.label'),
                    'class': 'product-status',
                    'render': function(item,index){
                        let $content = $('<div/>');

                        let $status = $('<select/>')
                        .attr('name','status')
                        .addClass("form-control form-control-sm")
                        .on('change',function(){
                            self.onChangeStatus(item,$content);
                        });

                        for(var i=0;i<3;i++){
                            let value = i;
                            let label = window.translate('product.status.'+value);
                            let selected = value == item.realStatus ? true : false;

                            let $option = $("<option/>")
                            .val(value)
                            .append(label);
                            if(selected){
                                $option.attr('selected','selected')
                            }

                            $status.append($option);
                        }

                        $content.append($status);

                        if(!self.target){
                            let $btnApplyAll = $('<button/>')
                            .addClass('btn btn-sm btn-success')
                            .append(window.translate('applyAll'))
                            .on('click',function(event){
                                self.onClickApplyAll(item,$content);
                            })
                            $content.append(
                                $('<div/>')
                                .addClass('mt-1 d-flex justify-content-center')
                                .append($btnApplyAll)
                            )
                        }

                        return $content;
                    }
                },
                {
                    'name': 'supplierPrice',
                    'label': window.translate('app.product.price.update.list.supplierPrice.label'),
                    'class': 'product-supplierPrice',
                    'render': function(item,index){
                        let $content = $('<div/>');


                        let $input = $('<input/>')
                        .addClass("form-control form-control-sm")
                        .attr('type','text')
                        .attr('name','supplierPrice')
                        .val(item.supplierPrice)
                        .on('change',function(){
                            self.onChangeSupplierPrice(item,$content);
                        });

                        let rfa = item.supplier.rfa ? item.supplier.rfa : 0;
                        let discount = item.supplierPrice- (item.supplierPrice * (rfa / 100));
                        let $discount = $('<small/>')
                        .addClass('discount text-muted')
                        .append(window.translate('discount'))
                        .append(' : ')
                        .append(window.formatFloat(discount)+' &euro;');

                        $content
                        .append($input)
                        .append(
                            $('<div/>')
                            .append($discount)
                        );

                        return $content;
                    }
                },
                {
                    'name': 'supplierPriceViewable',
                    'label': window.translate('app.product.price.update.list.supplierPriceViewable.label'),
                    'class': 'product-supplierPriceViewable',
                    'render': function(item,index){
                        let $content = $('<div/>');


                        let $input = $('<input/>')
                        .addClass("form-control form-control-sm")
                        .attr('type','text')
                        .attr('name','supplierPriceViewable')
                        .val(item.supplierPriceViewable)
                        .on('change',function(){
                            self.onChangeSupplierPriceViewable(item,$content);
                        });

                        let margin = ((item.supplierPriceViewable - item.supplierPrice) / item.supplierPrice) * 100;
                        let $margin = $('<small/>')
                        .addClass('margin text-muted')
                        .append(window.translate('margin'))
                        .append(' : ')
                        .append(window.formatFloat(margin)+' %');

                        $content
                        .append($input)
                        .append(
                            $('<div/>')
                            .append($margin)
                        );

                        return $content;
                    }
                },
                {
                    'name': 'price',
                    'label': window.translate('app.product.price.update.list.price.label'),
                    'class': 'product-price',
                    'render': function(item,index){
                        let $content = $('<div/>');


                        let $input = $('<input/>')
                        .addClass("form-control form-control-sm")
                        .attr('type','text')
                        .attr('name','price')
                        .val(item.realPrice)
                        .on('change',function(){
                            self.onChangePrice(item,$content);
                        });

                        let margin = ((item.realPrice - item.supplierPrice) / item.supplierPrice) * 100;
                        let $margin = $('<small/>')
                        .addClass('margin text-muted')
                        .append(window.translate('margin'))
                        .append(' : ')
                        .append(window.formatFloat(margin)+' %');

                        $content
                        .append($input)
                        .append(
                            $('<div/>')
                            .append($margin)
                        );

                        return $content;
                    }
                }
            ]
        });
    }

    compileListData(data){
        let listData = [];
        this.products = data.supplierProducts.edges;
        if(this.target){
            this.restaurantProducts = data.restaurantProducts.edges;
        }else{
            this.restaurantProducts = null;
        }

        for(var i in this.products){
            let product = this.products[i].node;

            let price = product.price;
            let status = product.status;
            if(this.restaurantProducts){
                for(var r in this.restaurantProducts){
                    let restaurantProduct = this.restaurantProducts[r].node;
                    if(restaurantProduct.product.id == product.id){
                        price = restaurantProduct.realPrice;
                        status = restaurantProduct.realStatus;
                    }
                }
            }

            product.realPrice = price;
            product.realStatus = status;

            listData.push(product);
        }
        return listData;
    }

    onChangeStatus(item,$cellContent){
        let status = $('select[name="status"]',$cellContent).val();
        this.submitStatus(item,status,$cellContent.parent());
    }

    onClickApplyAll(item,$cellContent){
        let status = $('select[name="status"]',$cellContent).val();
        this.submitApplyAll(item,status,$cellContent.parent());   
    }

    onChangeSupplierPrice(item,$cellContent){
        let value = parseFloat($('input[name="supplierPrice"]',$cellContent).val());
        if(!value){
            window.notify("notAFloat","error");
            return;
        }
        this.submitSupplierPrice(item,value,$cellContent.parent());
    }

    onChangeSupplierPriceViewable(item,$cellContent){
        let value = parseFloat($('input[name="supplierPriceViewable"]',$cellContent).val());
        if(!value){
            window.notify("notAFloat","error");
            return;
        }
        this.submitSupplierPriceViewable(item,value,$cellContent.parent());
    }

    onChangePrice(item,$cellContent){
        let value = parseFloat($('input[name="price"]',$cellContent).val());
        if(!value){
            window.notify("notAFloat","error");
            return;
        }
        this.submitPrice(item,value,$cellContent.parent());
    }
    setErrorCell($cell){
        $cell
        .addClass('bg-danger');
        $('.text-muted',$cell)
        .removeClass('text-muted')
        .addClass('text-white');
    }

    submitStatus(item,value,$cell){
        this.submitChange(item.id,'status',value,$cell);
    }

    submitSupplierPrice(item,value,$cell){
        this.submitChange(item.id,'supplierPrice',value,$cell);
    }

    submitSupplierPriceViewable(item,value,$cell){
        this.submitChange(item.id,'supplierPriceViewable',value,$cell);
    }

    submitPrice(item,value,$cell){
        this.submitChange(item.id,'price',value,$cell);
    }

    submitApplyAll(item,value,$cell){
        
        var self = this;
        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'products': {
                'value': [item.id],
                'type': '[Int]!'
            },
            'restaurants':{
                'value': [],
                'type': '[Int]!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteRestaurantProductVisibilities",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,"success");
                    self.refresh(function(){
                        self.table.focus(self.buildRowId(item.id));
                    });
                }else{
                    self.setErrorCell($cell);
                }
            },
            'error': function(message, xhr){
                self.setErrorCell($cell);
            },
            'after': function(){
            }
        });
        mutation.execute();
    }

    submitChange(productId,field,value,$cell){
        var self = this;
        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'product': {
                'value': productId,
                'type': 'Int!'
            }
        };
        if(field == 'status'){
            variables[field] = {
                'value': parseInt(value),
                'type': 'Int',
            };
        }else{
            variables[field] = {
                'value': parseFloat(value),
                'type': 'Float',
            };
        }
        if(this.target){
            variables['restaurant'] = {
                'value': parseInt(this.target),
                'type': 'Int',
            };
        }
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "UpdateSupplierProduct",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,"success");
                    self.refresh(function(){
                        self.table.focus(self.buildRowId(productId));
                    });
                }else{
                    self.setErrorCell($cell);
                }
            },
            'error': function(message, xhr){
                self.setErrorCell($cell);
            },
            'after': function(){
            }
        });
        mutation.execute();
    }

    getQueryParametersForActions(){

        let filters = {
        };

        if(this.$filterByNumber && this.$filterByNumber.val()){
            filters.number = this.$filterByNumber.val();
        }

        if(this.$filterByReference && this.$filterByReference.val()){
            filters.reference = this.$filterByReference.val();
        }

        if(this.$filterByRange && this.$filterByRange.val()){
            filters.range = parseInt(this.$filterByRange.val());
        }

        if(this.$filterBySupplier && this.$filterBySupplier.val()){
            filters.supplier_id = parseInt(this.$filterBySupplier.val());
        }else{
            filters.supplier_id = 'all';
        }

        let params = [];
        let keys = Object.keys(filters);
        for(var i in keys){
            let key = keys[i];
            let value = filters[key];
            params.push(key+'='+value);
        }

        return params.join('&');
    }

    bindEvents(){
        var self = this;

        this.$btnExportPdf.on('click',function(){
            //https://restofute-admin-old.wsextranet.net/resto-admin/products/exportProductsPdf/simple&range=13&number=&reference=&supplier_id=all
            let query = self.getQueryParametersForActions();
            let url = window.App.get('oldAdminHomeUrl') + '/products/exportProductsPdf/simple&'+query;

            window.downloadFile(url);
        });
        this.$btnExportExcel.on('click',function(){
            //https://restofute-admin-old.wsextranet.net/resto-admin/products/exportProducts/simple&range=13&number=&reference=&supplier_id=all
            let query = self.getQueryParametersForActions();
            let url = window.App.get('oldAdminHomeUrl') + '/products/exportProducts/simple&'+query;
            
            window.downloadFile(url);
        });
    }
}

module.exports = UpdateView;

